// extracted by mini-css-extract-plugin
export default {"SettingsSection":"DialListSettings_SettingsSection__neJSy","settingsTitle":"DialListSettings_settingsTitle__QCfuJ"};